import axios from '../utils/request';

export const getTickets = params =>
  axios.get('/tickets', {
    params,
  });

export const getTicketDetail = ({ id, agentId,tourGuideId }) =>
  axios.get(`/tickets/${id}`, { params: { agent_id: agentId,tour_guide_id:tourGuideId } });

// eslint-disable-next-line camelcase
export const getTicketDetailSeats = ({ id, date, ticket_type }) =>
  axios.get(`/seats/${id}`, {
    params: {
      use_date: date,
      ticket_type
    },
  });

export const getWeixinConfigParams = () => axios.get('/bonus_sdk');

export const getBonusId = code =>
  axios.get('/freecardo', { params: { sign_code: code } });

// 选择日期后获取场次信息
export const getTicketsType = ({id, date}) =>
  axios.get(`/ticket_type/${id}`, { params: { use_date: date } });
// export const getTicketsType = (id, date) =>{
//   console.log(id,date)
//   axios.get(`/ticket_type/${id}`, { params: { use_date: date } });
// }
export const getMapSdk = ({path}) => axios.get(`/new_sdk`,{params: { path }});

// export function getTicketsType(id,date){
//   console.log(id,date)
//   return axios.get(`/ticket_type/${id}`, { params: { use_date: date } });
// }